"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdditionalAgreementsReact = exports.AdditionalAgreements = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var AdditionalAgreementsReact = function AdditionalAgreementsReact(_ref) {
  var document = _ref.document,
    updateCheckbox = _ref.updateCheckbox;
  var error = document.error,
    applicationTermsAgreementChecked = document.applicationTermsAgreementChecked,
    esignAgreementChecked = document.esignAgreementChecked;
  var esignAgreementClasses = (0, _classnames.default)('esignAgreement', {
    error: error && !esignAgreementChecked
  });
  var applicationTermsAgreementClasses = (0, _classnames.default)('applicationTermsAgreement', {
    error: error && !applicationTermsAgreementChecked
  });
  var consentsBase = 'https://www.lendingclub.com';
  var esignHref = "".concat(consentsBase, "/apply/personal/popup?url=%2Fapply%2Fpersonal%2Flegal-agreement%2FSharedElectronicConsent");
  var creditProfileHref = "".concat(consentsBase, "/apply/personal/popup?url=%2Fapply%2Fpersonal%2Flegal-agreement%2FPersonalCreditProfileAuth");
  var privacyPolicyHref = "".concat(consentsBase, "/legal/privacy-policy");
  var applicationTermsHref = "".concat(consentsBase, "/apply/personal/popup?url=%2Fapply%2Fpersonal%2Flegal-agreement%2FApplicationTermsOfUse");
  var esignId = 'esignAgreement';
  var termsAgreementId = 'applicationTermsAgreement';
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "additionalAgreeent"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-wrapper"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: esignAgreementClasses,
    id: esignId,
    "data-test-id": esignId,
    name: esignId,
    value: esignAgreementChecked,
    onChange: function onChange() {
      updateCheckbox('esignAgreementChecked', !esignAgreementChecked);
    },
    type: "checkbox",
    checked: esignAgreementChecked,
    "aria-checked": esignAgreementChecked,
    "aria-invalid": error && !esignAgreementChecked,
    required: true
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "esignAgreement"
  }, "By checking this box, you (the applicant) acknowledge that you have received, read, and agree to all of the terms of the LendingClub ", /*#__PURE__*/_react.default.createElement("a", {
    href: esignHref,
    target: "_blank",
    rel: "noreferrer"
  }, "E-Sign Consent."))), /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-wrapper"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: applicationTermsAgreementClasses,
    id: termsAgreementId,
    "data-test-id": termsAgreementId,
    name: termsAgreementId,
    value: applicationTermsAgreementChecked,
    onChange: function onChange() {
      updateCheckbox('applicationTermsAgreementChecked', !applicationTermsAgreementChecked);
    },
    type: "checkbox",
    checked: applicationTermsAgreementChecked,
    "aria-checked": applicationTermsAgreementChecked,
    "aria-invalid": error && !applicationTermsAgreementChecked,
    required: true
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "applicationTermsAgreement"
  }, "By checking this box, you (the applicant) acknowledge that you have received, read, and agree to all of the terms of the LendingClub ", /*#__PURE__*/_react.default.createElement("a", {
    href: creditProfileHref,
    target: "_blank",
    rel: "noreferrer"
  }, " Credit Profile Authorization"), ", ", /*#__PURE__*/_react.default.createElement("a", {
    href: applicationTermsHref,
    target: "_blank",
    rel: "noreferrer"
  }, "Application Terms & Conditions"), ", and ", /*#__PURE__*/_react.default.createElement("a", {
    href: privacyPolicyHref,
    target: "_blank",
    rel: "noreferrer"
  }, "Privacy Policy."))));
};
exports.AdditionalAgreementsReact = AdditionalAgreementsReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    document: state
  };
};
AdditionalAgreementsReact.propTypes = {
  document: _propTypes.default.object.isRequired,
  updateCheckbox: _propTypes.default.func.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var AdditionalAgreements = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdditionalAgreementsReact);
exports.AdditionalAgreements = AdditionalAgreements;
